var _rect, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditiconblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#003B5B",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1059 17.7979H12.875C12.6335 17.7979 12.4375 17.6019 12.4375 17.3604C12.4375 17.1189 12.6335 16.9229 12.875 16.9229H17.1059C17.3474 16.9229 17.5434 17.1189 17.5434 17.3604C17.5434 17.6019 17.3474 17.7979 17.1059 17.7979Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1456_16301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 11,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16797 6.75H16.19V17.7981H6.16797V6.75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1456_16301)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.649 7.92638L7.15688 14.7951C7.05713 14.92 7.02038 15.081 7.05713 15.2355L7.45438 16.9185L9.22713 16.8963C9.39571 16.8945 9.55146 16.8193 9.65471 16.691C11.5313 14.343 15.1089 9.86654 15.2104 9.73529C15.306 9.58013 15.3434 9.36079 15.2932 9.14963C15.2419 8.93321 15.1071 8.74946 14.9129 8.63221C14.8715 8.60363 13.8885 7.84063 13.8582 7.81671C13.4884 7.52037 12.9488 7.57171 12.649 7.92638ZM7.10905 17.7981C6.90663 17.7981 6.73046 17.6593 6.68321 17.4615L6.20546 15.4368C6.10688 15.0174 6.20488 14.5845 6.4738 14.2485L11.9688 7.37571C11.9711 7.37337 11.9729 7.37046 11.9752 7.36812C12.5778 6.64771 13.6675 6.54154 14.4025 7.13129C14.4316 7.15404 15.4075 7.91237 15.4075 7.91237C15.7622 8.12354 16.0393 8.50096 16.1443 8.94779C16.2487 9.38996 16.1729 9.84612 15.9296 10.2317C15.9115 10.2603 15.8958 10.2848 10.3378 17.2381C10.07 17.5718 9.66871 17.766 9.23763 17.7713L7.11488 17.7981H7.10905Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4655 11.8156C14.3721 11.8156 14.2788 11.7859 14.1989 11.7252L11.0185 9.28223C10.8272 9.13523 10.791 8.86106 10.938 8.66856C11.0856 8.47723 11.3598 8.44164 11.5517 8.58864L14.7326 11.0311C14.924 11.1781 14.9601 11.4528 14.8125 11.6447C14.7268 11.7567 14.5967 11.8156 14.4655 11.8156Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditiconblue);
export default __webpack_public_path__ + "static/media/editiconblue.0923989a62a1f515d10036c2f6bde17d.svg";
export { ForwardRef as ReactComponent };